// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"07acb57f","839":"8df5e58e"}[chunkId] + ".chunk.js";
};